// extracted by mini-css-extract-plugin
module.exports = {"block":"AuthPage_block__S3gT6"};